/**
 * Session state for the app shell: the shared hook, over Realea's user.
 * Refetch via `refresh()` after sign-in or genLogout to re-sync.
 */import useSharedSession from"web/shared/hooks/useSession";import{genSessionUser}from"web/realea/session/auth";export default function useSession(){return useSharedSession(genSessionUser);}